import type { Program } from "../types/content";

export const programs: Program[] = [
  {
    slug: "energy-resilience",
    status: "In development",
    accent: "blue",
    title: {
      en: "Energy Resilience",
      ro: "Rezilienta energetica",
      he: "חוסן אנרגטי"
    },
    summary: {
      en: "Energy storage, management, flexibility, efficiency and resilient infrastructure.",
      ro: "Stocare, management energetic, flexibilitate, eficienta si infrastructura rezilienta.",
      he: "אגירת אנרגיה, ניהול, גמישות, יעילות ותשתיות עמידות."
    },
    body: {
      en: ["We help organizations define the operational problem before considering BESS, EMS, peak management, backup resilience or renewable integration.", "The program focuses on feasibility, financing pathways and evidence from pilots."],
      ro: ["Ajutam organizatiile sa defineasca problema operationala inainte de a analiza BESS, EMS, reducerea varfurilor, rezilienta de backup sau integrarea activelor regenerabile.", "Programul pune accent pe fezabilitate, cai de finantare si dovezi obtinute din pilotari."],
      he: ["אנו מסייעים לארגונים להגדיר את הבעיה התפעולית לפני בחינת אגירה, EMS, ניהול עומסים, גיבוי או שילוב אנרגיה מתחדשת.", "התוכנית מתמקדת בהיתכנות, מסלולי מימון וראיות מפיילוטים."]
    },
    focus: {
      en: ["BESS and EMS assessment", "Flexible consumption", "Backup resilience", "Existing renewable assets"],
      ro: ["Evaluare BESS si EMS", "Consum flexibil", "Rezilienta de backup", "Active regenerabile existente"],
      he: ["בחינת BESS ו-EMS", "צריכה גמישה", "חוסן גיבוי", "נכסים מתחדשים קיימים"]
    }
  },
  {
    slug: "climate-smart-agriculture",
    status: "Research",
    accent: "cyan",
    title: {
      en: "Climate-Smart Agriculture",
      ro: "Agricultura adaptata climatic",
      he: "חקלאות מותאמת אקלים"
    },
    summary: {
      en: "Water, agrivoltaics, irrigation, crop resilience and agricultural technologies.",
      ro: "Apa, agrivoltaice, irigare, rezilienta culturilor si tehnologii agricole.",
      he: "מים, אגרו-וולטאיקה, השקיה, חוסן יבולים וטכנולוגיות חקלאיות."
    },
    body: {
      en: ["This program connects agricultural pressure points with measurable technology and finance options.", "It is designed for farms, processors, communities and sector organizations."],
      ro: ["Programul conecteaza presiunile agricole cu optiuni tehnologice si financiare masurabile.", "Este gandit pentru ferme, procesatori, comunitati si organizatii sectoriale."],
      he: ["התוכנית מחברת את נקודות הלחץ בחקלאות עם טכנולוגיות ומימון שניתן למדוד.", "היא מיועדת לחוות, מעבדים, קהילות וארגוני ענף."]
    },
    focus: {
      en: ["Water efficiency", "Agrivoltaics", "Irrigation", "Crop resilience"],
      ro: ["Eficienta apei", "Agrivoltaice", "Irigare", "Rezilienta culturilor"],
      he: ["יעילות מים", "אגרו-וולטאיקה", "השקיה", "חוסן יבולים"]
    }
  },
  {
    slug: "green-wine-moldova",
    status: "Pilot preparation",
    accent: "burgundy",
    title: {
      en: "Green Wine Moldova",
      ro: "Green Wine Moldova",
      he: "Green Wine Moldova"
    },
    summary: {
      en: "From sustainable vineyard to sustainable bottle.",
      ro: "De la vie sustenabila la sticla sustenabila.",
      he: "מהכרם המקיים ועד הבקבוק המקיים."
    },
    body: {
      en: ["Green Wine Moldova is a program, not a product. It can connect producers, technology providers, researchers, financing institutions and sector organizations around measurable sustainability.", "No organization is presented as an official partner until that status is confirmed."],
      ro: ["Green Wine Moldova este un program, nu un produs. Poate conecta producatori, furnizori de tehnologie, cercetatori, institutii de finantare si organizatii sectoriale in jurul sustenabilitatii masurabile.", "Nicio organizatie nu este prezentata ca partener oficial fara confirmare."],
      he: ["Green Wine Moldova היא תוכנית, לא מוצר. היא יכולה לחבר יצרנים, ספקי טכנולוגיה, חוקרים, מוסדות מימון וארגוני ענף סביב קיימות מדידה.", "אף ארגון אינו מוצג כשותף רשמי ללא אישור."]
    },
    focus: {
      en: ["Vineyard resilience", "Winery energy", "Storage and efficiency", "European market evidence"],
      ro: ["Rezilienta viei", "Energia cramei", "Stocare si eficienta", "Dovezi pentru piata europeana"],
      he: ["חוסן הכרם", "אנרגיית היקב", "אגירה ויעילות", "ראיות לשוק האירופי"]
    }
  },
  {
    slug: "energy-communities",
    status: "Research",
    accent: "blue",
    title: {
      en: "Energy Communities",
      ro: "Comunitati energetice",
      he: "קהילות אנרגיה"
    },
    summary: {
      en: "Community-scale energy models, public-benefit pilots, education and local resilience.",
      ro: "Modele energetice la nivel comunitar, pilotari de beneficiu public, educatie si rezilienta locala.",
      he: "מודלים קהילתיים לאנרגיה, פיילוטים לתועלת הציבור, חינוך וחוסן מקומי."
    },
    body: {
      en: ["The program explores public-benefit energy models that can be understood, governed and measured locally.", "It prioritizes transparent design and education before scale."],
      ro: ["Programul exploreaza modele energetice de beneficiu public care pot fi intelese, guvernate si masurate local.", "Prioritizeaza designul transparent si educatia inainte de scalare."],
      he: ["התוכנית בוחנת מודלים קהילתיים לתועלת הציבור שניתן להבין, לנהל ולמדוד באופן מקומי.", "היא נותנת קדימות לעיצוב שקוף ולחינוך לפני הרחבה."]
    },
    focus: {
      en: ["Public-benefit pilots", "Education", "Local resilience", "Community governance"],
      ro: ["Pilotari de beneficiu public", "Educatie", "Rezilienta locala", "Guvernanta comunitara"],
      he: ["פיילוטים לתועלת הציבור", "חינוך", "חוסן מקומי", "ממשל קהילתי"]
    }
  }
];
